import { FC, useMemo } from 'react';
import { VisitConfig } from '@dynamika-shared/types/visits';
import { CohortType } from '@dynamika-shared/types/cohorts';
import { useFormContext } from 'react-hook-form';
import { CheckboxList, GenericItem } from '../CheckboxList';

type ScopeItem = VisitConfig | CohortType;

type ScopeItemsListProps = {
  items: CohortType[] | Record<string, VisitConfig[]>;
};

export const ScopeItemsList: FC<ScopeItemsListProps> = ({ items }) => {
  const { setValue, watch } = useFormContext();
  const scope = watch('scope');

  const toggleInArray = (item: ScopeItem, elements: string[]) => {
    if (elements.find(elId => elId === item.id)) {
      return elements.filter(elId => elId !== item.id);
    } else {
      return [...elements, item.id];
    }
  };

  const selectedItems = useMemo(() => {
    if (!scope?.type) return [];
    return scope?.type === '.Visit'
      ? scope?.visitDefinitions
      : scope?.cohorts || [];
  }, [scope?.cohorts, scope?.type, scope?.visitDefinitions]);

  const clickHandler = (item: GenericItem) => {
    if (scope?.type === '.Visit') {
      setValue('scope', {
        ...scope,
        visitDefinitions: toggleInArray(
          item as VisitConfig,
          scope?.visitDefinitions || []
        ),
      });
    } else {
      setValue('scope', {
        ...scope,
        cohorts: toggleInArray(item as CohortType, scope?.cohorts || []),
      });
    }
  };

  return (
    <CheckboxList
      items={items.length ? { hidden: items as CohortType[] } : items as Record<string, GenericItem[]>}
      onItemToggle={clickHandler}
      selectedItems={selectedItems}
      disabled={scope?.type === '.Visit' && scope.allRegular}
    />
  );
};
